import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { setSubscriptionTier } from 'Pods/SearchPage/Store/actions/pricing'
import { SUBSCRIPTION_TIER } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function SubscriptionTier() {
  const translate = useTranslate()

  const withSubscription = useSearchPageStore(state => state.withSubscription)
  const subscriptionTier = useSearchPageStore(state => state.subscriptionTier)

  // Nothing is checked until the search really is a subscription one: "All" means every
  // subscription tier, not every model.
  const selectedFilters = useMemo(() => {
    if (!withSubscription) return EMPTY_ARRAY

    return [subscriptionTier ?? SUBSCRIPTION_TIER.ALL]
  }, [withSubscription, subscriptionTier])

  // Essentials/Premium are plan names, so they stay untranslated - same as the legacy listing.
  const filters = useMemo(() => [{
    label: translate('search_page.filters.price.with_subscription'),
    filters: [
      { value: SUBSCRIPTION_TIER.ALL, label: translate('search_page.filters.price.subscription_all') },
      { value: SUBSCRIPTION_TIER.ESSENTIALS, label: 'Essentials' },
      { value: SUBSCRIPTION_TIER.PREMIUM, label: 'Premium' },
    ],
  }], [translate])

  const handleFilterChange = useCallback((_, value) => {
    setSubscriptionTier(value)
  }, [])

  return (
    <div className="price-filter__subscription-tier">
      <FiltersSidebar
        isCollapsible={false}
        filters={filters}
        selectedFilters={selectedFilters}
        onFiltersChange={handleFilterChange}
        limit={0}
        useRadio
        hideLastDivider
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
    </div>
  )
}

export default memo(SubscriptionTier)
